const { SET_USER_FAVORITE_BRANDS } = require('constants/actionTypes/brandsList');

function setUserFavoriteBrandIDs(userFavoriteBrandIDs) {
    return {
        type: SET_USER_FAVORITE_BRANDS,
        payload: { userFavoriteBrandIDs }
    };
}

module.exports = {
    setUserFavoriteBrandIDs
};
